import styled from 'styled-components';
import { useAnalytics } from '@lower-financial/analytics';
import { PersonImage } from '@lower-financial/core-components/src';
import { TerminalScreenLayout } from '@lightspeed/components/shared/terminal-screen-layout/terminal-screen-layout';
import { useMortgageApplication } from '@lightspeed/contexts/mortgage-application-context/mortgage-application-context';
import { getMarketingUrl } from '@lightspeed/utils/get-marketing-url';
import { EmailBanner } from '@lightspeed/components/ui/pages/verify-email/email-banner';

export const JumpstartManualIntervention = () => {
  const { mortgageApplication } = useMortgageApplication();

  const fireAnalyticsEvent = useAnalytics('jumpstart_manual_intervention');

  const closeButtonUrl = getMarketingUrl(mortgageApplication.loanPurpose);

  return (
    <TerminalScreenLayout
      heading={'We need more information.'}
      subtext={'We don’t have enough information to automatically pre-approve you, but we’re excited to discuss further.'}
      iconComponent={<ChelseaImage />}
      animations={false}
      fireAnalyticsEvent={fireAnalyticsEvent}
      closeButtonUrl={closeButtonUrl}
      callToAction={(
        <EmailBanner
          heading={'Check your email.'}
          body={'We sent you an email with information about the next steps to complete your application.'}
        />
      )}
    />
  );
};

const ChelseaImage = styled(PersonImage)({
  height: 300,
  width: 300,
});
